import { useEffect } from "react"
import { useToggle } from "react-use"

import { useGetClientPaymentMethods } from "modules/ClientAccount/hooks"
import { RadioGroup, Text } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { CURRENCY } from "utils/constants"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import {
    CardOneItem,
    CardItem,
    CardItemAnother,
    Discounts,
    CurrencySelectorBooking,
} from "modules/BookingCommon/components"
import { formatToyLd } from "utils/datetime-format-utils"

export function PaymentMethodsBlock() {
    const [
        { currency, payByCard, bookingDetails, selectedService, selectedDiscount },
        { setCurrency, setPayByCard, changeDiscount },
    ] = usePaymentContext()
    const { data: cards = [] } = useGetClientPaymentMethods()
    const [isEdit, toggleIsEdit] = useToggle(false)
    const [{ isVerified }] = useClientContext()

    useEffect(() => {
        if (cards.length > 0) {
            setPayByCard(cards[0])
        }
    }, [cards])
    const date = bookingDetails
        ? formatToyLd(new Date(bookingDetails.start_datetime_client_tz))
        : undefined
    return (
        <div className="booking-form">
            <>
                <div className="booking-form__title-wrapper">
                    <Text className="mgb-4 is-inline-block" isAccent>
                        Способ оплаты
                    </Text>
                    {!isEdit && cards.length > 0 && (
                        <Icon
                            type="edit"
                            size={19}
                            className="cursor-pointer"
                            onClick={() => toggleIsEdit(true)}
                        />
                    )}
                </div>
                {cards.length === 0 && (
                    <CurrencySelectorBooking currency={currency} onChange={setCurrency} />
                )}
                {cards.length > 0 && !isEdit && <CardOneItem card={payByCard} />}
                {cards.length > 0 && isEdit && (
                    <>
                        {" "}
                        <CurrencySelectorBooking currency={currency} onChange={setCurrency} />
                        {currency === CURRENCY.RUB && (
                            <div className="booking-form__card-list">
                                <RadioGroup>
                                    {cards.map((item) => (
                                        <CardItem
                                            card={item}
                                            payExternalId={payByCard?.external_id}
                                            onChange={setPayByCard}
                                            key={item.external_id}
                                        />
                                    ))}
                                    <CardItemAnother
                                        payByCard={payByCard}
                                        onChange={() => setPayByCard(null)}
                                        key={0}
                                    />
                                </RadioGroup>
                            </div>
                        )}
                    </>
                )}
            </>
            <>
                <hr className="booking-form__discount-divider" />
                <Discounts
                    psy={bookingDetails.psy}
                    email={bookingDetails?.client_email}
                    selectedService={selectedService}
                    selectedDiscount={selectedDiscount}
                    hasPreviousSessions={isVerified}
                    bookingId={bookingDetails.booking_id}
                    date={date}
                    onChangeDiscount={changeDiscount}
                />
            </>
        </div>
    )
}
